import { Component, OnInit } from '@angular/core';
import { DonneReferenceService } from '../shared/services/donne-reference.service';
import { Store, Select } from '@ngxs/store';
import { GoNextPage } from '../octroi/octroi.state';
import { Observable } from 'rxjs';
import { UpdateClickTelAssurancePret } from '../shared/personne.state';
import { SetCurrentCodePage } from '../shared/navigation.state';
import { Router } from '@angular/router';

@Component({
  selector: 'app-assurance-pret',
  templateUrl: './assurance-pret.component.html',
  styleUrls: ['./assurance-pret.component.scss'],
  standalone: false
})
export class AssurancePretComponent implements OnInit {
  @Select(state => state.octroi.isCompleted)
  isOctroiCompleted$: Observable<boolean>;

  isOctroiCompleted = false;

  constructor(
    private readonly _store: Store,
    private readonly _donneesReferencesService: DonneReferenceService,
    private readonly _router: Router
  ) {}

  ngOnInit() {
    this._store.dispatch(new SetCurrentCodePage('accueil_assurance'));

    this.isOctroiCompleted$.subscribe(data => {
      this.isOctroiCompleted = data;
    });
  }

  get telephoneAssurancePretSansFrais() {
    return this._donneesReferencesService.numerosDemandeSupport.assurancePretSansFrais;
  }

  navigate(): void {
    this._store.dispatch(new GoNextPage());
  }

  updateDernierAppel() {
    this._store.dispatch(new UpdateClickTelAssurancePret());
  }
}
